import React from 'react'
import { useStore } from 'react-redux'

export function withReduxStoreForwardRef(WrappedComponent) {
  return React.forwardRef(function(props, ref) {
    const store = useStore()
    return <WrappedComponent ref={ref} reduxStore={store} {...props} />
  })
}

export default function withReduxStore(WrappedComponent) {
  return function(props) {
    const store = useStore()
    return <WrappedComponent reduxStore={store} {...props} />
  }
}
